/**
 * View-as chrome for staff sessions (SUPER_ADMIN/ADMIN/EMPLOYEE) with a
 * ?clientId= selection in the URL. Rendered by the Shell above the routed
 * page content.
 */

/**
 * Slim persistent banner: "Viewing as {client}" + an Exit action that drops
 * the clientId param and returns to the role home (/agency for admins,
 * /my-clients for employees). Accent-tinted like the other callout bands.
 */
export function ViewAsBanner({ clientName, onExit }) {
  return (
    <div className="mb-4 rounded-card border border-accent-border bg-accent-bg px-4 py-2 flex items-center justify-between gap-4">
      <div className="text-[12px] text-text-primary truncate">
        Viewing as <span className="font-semibold">{clientName}</span>
      </div>
      <button
        type="button"
        onClick={onExit}
        className="text-[12px] text-accent hover:underline font-medium flex-shrink-0"
      >
        Exit
      </button>
    </div>
  );
}

/**
 * Error state for a bad/stale ?clientId= (client deleted, or outside an
 * employee's scope). Replaces the routed content — without this the fetch
 * failure was silently ignored and the sidebar just collapsed.
 */
export function ViewAsError({ error, backLabel, onBack }) {
  return (
    <div className="bg-surface border border-border-default rounded-card p-8 text-center max-w-md mx-auto mt-10">
      <div className="w-10 h-10 rounded-full bg-[#fef2f2] flex items-center justify-center mx-auto mb-3">
        <span className="text-negative text-[16px] font-bold">!</span>
      </div>
      <div className="text-[13px] font-semibold text-text-primary mb-1">
        Couldn't load this client
      </div>
      <div className="text-[12px] text-text-secondary mb-4">
        {error?.message || "The selected client may have been removed, or you may not have access to it."}
      </div>
      <button
        type="button"
        onClick={onBack}
        className="text-[12px] text-accent hover:underline font-medium"
      >
        {backLabel}
      </button>
    </div>
  );
}
